<template>
  <div class="smaller-container-wrapper mb-5 pb-5">
    <div class="row">
      <div class="col-sm-10">
        <div class="mb-5">
          <h4 class="mb-3">{{ $t('message.buildAndPrice.colourSelect.selectExterior') }}</h4>
          <div class="row mb-2">
            <div class="col option-label">{{ selectedExteriorLabel }}</div>
            <div :class="{ hide: !selectedExteriorMsrp }" class="col price mb-2 text-right">
              + {{ $n(selectedExteriorMsrp, 'currencyDollars', languageCode) }}
            </div>
          </div>
          <ColourSelect v-model="exteriorColor" name="exteriorColors" :options="formattedExteriorColorOptions">
          </ColourSelect>
        </div>
        <div class="mb-5">
          <h4 class="mb-0">{{ $t('message.buildAndPrice.colourSelect.selectInterior') }}</h4>
          <div :class="{ hide: !selectedInteriorMsrp }" class="price mb-2">
            + {{ $n(selectedInteriorMsrp, 'currencyDollars', languageCode) }}
          </div>
          <MobialisFancyRadio v-model="interiorColor" name="interiorColors" :textArray="formattedInteriorColorOptions">
          </MobialisFancyRadio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ColourSelect from '@/components/build-and-price/ColourSelect.vue';

export default {
  name: 'ColoursSelect',
  components: { ColourSelect },
  created() {
    this.setDefaults();
  },
  computed: {
    ...mapState('buildAndPrice', ['vehicleConfig', 'selectedOptions']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    interiorColor: {
      get() {
        return this.selectedOptions.interiorColor ? this.selectedOptions.interiorColor.value : null;
      },
      set(value) {
        this.selectOption('interiorColor', value);
      },
    },
    exteriorColor: {
      get() {
        return this.selectedOptions.exteriorColor ? this.selectedOptions.exteriorColor.value : null;
      },
      set(value) {
        this.selectOption('exteriorColor', value);
      },
    },
    selectedInteriorMsrp() {
      return this.selectedOptions.interiorColor ? this.selectedOptions.interiorColor.msrp : null;
    },
    selectedExteriorMsrp() {
      return this.selectedOptions.exteriorColor ? this.selectedOptions.exteriorColor.msrp : null;
    },
    selectedExteriorLabel() {
      return this.selectedOptions.exteriorColor ? this.selectedOptions.exteriorColor.label : null;
    },
    vehicleConfigExteriorColorOptions() {
      return Object.values(this.vehicleConfig.options).filter(
        value => value.headerId === this.enums.BuildAndPriceOptions.EXTERIOR_COLOR
      );
    },
    vehicleConfigInteriorColorOptions() {
      return Object.values(this.vehicleConfig.options).filter(
        value => value.headerId === this.enums.BuildAndPriceOptions.INTERIOR_COLOR
      );
    },
    formattedInteriorColorOptions() {
      return this.formatOption(this.vehicleConfigInteriorColorOptions);
    },
    formattedExteriorColorOptions() {
      return this.formatOption(this.vehicleConfigExteriorColorOptions);
    },
  },
  methods: {
    formatOption(vehicleConfigOptions) {
      const formattedOptions = [];
      vehicleConfigOptions.forEach(element => {
        formattedOptions.push({
          label: element.descriptions[0].description,
          value: element.chromeOptionCode,
          msrp: element.msrp,
          hexCode: element.rgbValue ? `#${element.rgbValue}` : null,
        });
      });
      // Order by price and label name
      formattedOptions.sort((a, b) => a.msrp - b.msrp || a.label.localeCompare(b.label));
      return formattedOptions;
    },
    async selectOption(name, value) {
      if (!this.selectedOptions[`${name}`] || value !== this.selectedOptions[`${name}`].value) {
        this.$store.commit('SET_LOADING', true);
        const payload = {
          serializedValue: this.vehicleConfig.serializedValue,
          optionCode: value,
        };
        try {
          const options = this[`formatted${name[0].toUpperCase() + name.substring(1)}Options`];
          const selectedOption = options.filter(item => item.value === value)[0];
          this.$store.commit('buildAndPrice/SET_SELECTED_OPTION', [`${name}`, selectedOption]);
          await this.$store.dispatch('buildAndPrice/postVehicleOption', payload);
          if (this.exteriorColor && this.interiorColor) {
            this.$store.commit('SET_LOADING', false);
          }
        } catch (e) {
          this.$router.push('error');
          this.$store.commit('SET_LOADING', false);
          this.$log('Error posting vehicle option', e);
        }
      }
    },
    async setDefaults() {
      if (!this.selectedOptions.exteriorColor) {
        await this.selectOption('exteriorColor', this.formattedExteriorColorOptions[0].value);
      }
      if (!this.selectedOptions.interiorColor) {
        await this.selectOption('interiorColor', this.formattedInteriorColorOptions[0].value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.price {
  color: #4b5863;
  font-weight: 700;
  text-align: right;
  &.hide {
    opacity: 0;
  }
}

.option-label {
  font-weight: 700;
  color: #6d7783;
}
</style>
